import TrashCan from "@assets/images/trash.svg";
import { Grid } from "@material-ui/core";
import MultipleSelect from "@saleor/changeOrderExport/components/OrderStatus";
import MyTypography from "@saleor/components/MyTypography";
import SingleTextField from "@saleor/components/SingleTextField";
import TextInputDisable from "@saleor/components/TextInputDisable";
import { ScgpUserQuery, useGetRoleListByGroupQuery } from "@saleor/graphql";
import UserAD from "@saleor/userManagement/components/UserAD/UserAD";
import { UserDetailMode } from "@saleor/userManagement/constants";
import React, { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

import FormSwitchActive from "./FormSwtichActive";
import useStyles from "./styles";

interface FormOtherProps {
  formik?: any;
  groupId?: string;
  handleOpenDelete: () => void;
  handleOnKeyPress: (e: any) => void;
  handleOnPaste: (e: any) => void;
  user?: ScgpUserQuery;
  mode?: UserDetailMode;
}

const FormOther: React.FC<FormOtherProps> = ({
  formik,
  groupId,
  user,
  handleOpenDelete,
  handleOnKeyPress,
  handleOnPaste,
  mode
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const [groupInitialized, setGroupInitialized] = useState(false);

  const {
    data: dataRoleListByGroupId,
    loading: loadingRoleListByGroupId,
    refetch: refetchRoleListByGroupId
  } = useGetRoleListByGroupQuery({
    variables: {
      id: groupId
    }
  });

  useEffect(() => {
    if (!groupInitialized && groupId) {
      setGroupInitialized(true);
    } else if (groupInitialized) {
      formik.setFieldValue("userRoles", []);
    }
    refetchRoleListByGroupId();
  }, [groupId]);

  const userRoleOptions =
    !loadingRoleListByGroupId &&
    dataRoleListByGroupId?.parentGroup?.groups?.map(data => ({
      label: data.name,
      value: data.id
    }));

  const getErrorText = field =>
    mode !== UserDetailMode.VIEW ? (
      <div className={classes.textError}>{formik.errors[field]}</div>
    ) : (
      ""
    );

  return (
    <>
      {mode !== UserDetailMode.VIEW && (
        <>
          <Grid item md={6} data-testid>
            <MyTypography variant={"subtitle3"} className={classes.inputLabel}>
              {intl.formatMessage({ defaultMessage: "ชื่อ" })}
              <span className={classes.required}>*</span>
            </MyTypography>
            <TextInputDisable
              value={formik.values.firstName || ""}
              testId="firstName-readonlyInput"
            />
            {getErrorText("firstName")}
          </Grid>
          <Grid item md={6}>
            <MyTypography variant={"subtitle3"} className={classes.inputLabel}>
              {intl.formatMessage({ defaultMessage: "นามสกุล" })}
              <span className={classes.required}>*</span>
            </MyTypography>
            <TextInputDisable
              value={formik.values.lastName || ""}
              testId="lastName-readonlyInput"
            />
            {getErrorText("lastName")}
          </Grid>
        </>
      )}
      <Grid item md={6}>
        {mode === UserDetailMode.VIEW ? (
          <>
            <MyTypography variant={"subtitle3"} className={classes.inputLabel}>
              {intl.formatMessage({ defaultMessage: "User Roles" })}
            </MyTypography>
            <MyTypography variant={"body3"} data-testid="userRoles-text">
              {user?.scgpUser?.permissionGroups?.map(x => x?.name)?.join(", ")}
            </MyTypography>
          </>
        ) : (
          <>
            <MyTypography variant={"subtitle3"} className={classes.inputLabel}>
              {intl.formatMessage({ defaultMessage: "User Roles" })}
              <span className={classes.required}>*</span>
            </MyTypography>
            {userRoleOptions && userRoleOptions.length > 0 && (
              <MultipleSelect
                showChipDeleteButton={false}
                showCircularIcon={false}
                choices={userRoleOptions}
                name="userRoles"
                placeholder="เลือก User Roles"
                numberItemDisplay={2}
                value={formik.values.userRoles}
                onChange={formik.handleChange}
                error={!!formik.errors.userRoles}
              />
            )}
            {getErrorText("userRoles")}
          </>
        )}
      </Grid>
      <Grid item md={6}>
        {mode === UserDetailMode.CREATE || mode === UserDetailMode.EDIT ? (
          <UserAD formik={formik} mode={mode} />
        ) : (
          <>
            <MyTypography variant={"subtitle3"} className={classes.inputLabel}>
              {intl.formatMessage({ defaultMessage: "AD User" })}
            </MyTypography>
            <MyTypography variant={"body3"} data-testid="adUser-text">
              {user?.scgpUser?.extendData?.adUser || "-"}
            </MyTypography>
          </>
        )}
      </Grid>
      <Grid item md={6}>
        {mode === UserDetailMode.VIEW ? (
          <>
            <MyTypography variant={"subtitle3"} className={classes.inputLabel}>
              {intl.formatMessage({ defaultMessage: "E-mail" })}
            </MyTypography>
            <MyTypography variant={"body3"} data-testid="email-text">
              {user?.scgpUser?.email || "-"}
            </MyTypography>
          </>
        ) : (
          <>
            <MyTypography variant={"subtitle3"} className={classes.inputLabel}>
              {intl.formatMessage({ defaultMessage: "E-mail" })}
              <span className={classes.required}>*</span>
            </MyTypography>
            <TextInputDisable
              value={formik.values.email || ""}
              testId="email-readonlyInput"
            />
            {getErrorText("email")}
          </>
        )}
      </Grid>
      <Grid item md={6}>
        {mode === UserDetailMode.VIEW ? (
          <>
            <MyTypography variant={"subtitle3"} className={classes.inputLabel}>
              {intl.formatMessage({ defaultMessage: "Employee ID" })}
            </MyTypography>
            <MyTypography variant={"body3"} data-testid="employeeId-text">
              {user?.scgpUser?.extendData?.employeeId || "-"}
            </MyTypography>
          </>
        ) : (
          <>
            <MyTypography variant={"subtitle3"} className={classes.inputLabel}>
              {intl.formatMessage({ defaultMessage: "Employee ID" })}
              <span className={classes.required}>*</span>
            </MyTypography>
            <TextInputDisable
              value={formik.values.employeeId || ""}
              testId="employeeId-readonlyInput"
            />
            {getErrorText("employeeId")}
          </>
        )}
      </Grid>
      <Grid item md={6}>
        {mode === UserDetailMode.VIEW ? (
          <>
            <MyTypography variant={"subtitle3"} className={classes.inputLabel}>
              {intl.formatMessage({ defaultMessage: "SAP ID" })}
            </MyTypography>
            <MyTypography variant={"body3"} data-testid="sapId-text">
              {user?.scgpUser?.extendData?.sapId || "-"}
            </MyTypography>
          </>
        ) : (
          <>
            <MyTypography variant={"subtitle3"} className={classes.inputLabel}>
              {intl.formatMessage({ defaultMessage: "SAP ID" })}
            </MyTypography>
            <SingleTextField
              name={"sapId"}
              id="sapId"
              placeholder="ระบุ SAP ID"
              value={formik.values.sapId}
              onChange={formik.handleChange}
              onKeyPress={handleOnKeyPress}
              onPaste={handleOnPaste}
              maxLengthProps={12}
              textUpperCase
            />
          </>
        )}
      </Grid>
      <Grid item md={6} />
      <FormSwitchActive formik={formik} user={user} mode={mode} />

      {mode === UserDetailMode.EDIT ? (
        <Grid item md={6}>
          <SVG
            src={TrashCan}
            cursor="pointer"
            onClick={handleOpenDelete}
            data-testid="deleteUserButton"
          />
        </Grid>
      ) : null}
    </>
  );
};

export default FormOther;
